import { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

function FlagIcon({ code, size = 20 }) {
  return (
    <img
      src={`https://flagcdn.com/w40/${code}.png`}
      srcSet={`https://flagcdn.com/w80/${code}.png 2x`}
      alt={code}
      width={size}
      height={Math.round(size * 0.75)}
      className="rounded-sm object-cover inline-block"
      style={{ minWidth: size }}
    />
  );
}

export default function LanguageSelector() {
  const { language, setLanguage, LANGUAGES } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid="language-selector">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border border-border/50 hover:bg-secondary smooth-transition text-sm"
        data-testid="language-selector-trigger"
      >
        <FlagIcon code={current.flag} size={20} />
        <span className="hidden sm:inline text-xs text-muted-foreground">{current.code.toUpperCase()}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-card border border-border rounded-xl shadow-lg overflow-hidden z-50 min-w-[140px]" data-testid="language-dropdown">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => { setLanguage(lang.code); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-secondary smooth-transition ${
                language === lang.code ? 'bg-accent/10 text-accent font-medium' : 'text-primary'
              }`}
              data-testid={`lang-option-${lang.code}`}
            >
              <FlagIcon code={lang.flag} size={20} />
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
